import zod from "zod";

export const CreateAccountSchema = zod
  .object({
    nombre: zod
      .string()
      .min(3, { message: "El nombre debe tener al menos 3 letras" }),
    apellido: zod
      .string()
      .min(3, { message: "El apellido debe tener al menos 3 letras" }),
    correo: zod.string().email({ message: "Debe ingresar un correo valido" }),
    password: zod
      .string()
      .min(8, { message: "La contraseña debe ser de al menos 8 digitos" })
      .regex(
        /[a-z]/,
        "La contraseña debe contener al menos una letra minúscula."
      )
      .regex(
        /[A-Z]/,
        "La contraseña debe contener al menos una letra mayúscula."
      )
      .regex(/[0-9]/, "La contraseña debe contener al menos un número.")
      .regex(
        /[\W_]/,
        "La contraseña debe contener al menos un carácter especial."
      ),
    passwordConfirmation: zod.string(),
    rolCartera: zod.object({
      id: zod.number(),
    }),
    suscripcion: zod.boolean(),
    rolApp: zod.object({
      id: zod.number(),
    }),
    fechaSuscripcion: zod.string(),
  })
  .refine(
    (data) => {
      return data.password === data.passwordConfirmation;
    },
    {
      message: "Las contraseñas deben coinicidir.",
      path: ["passwordConfirmation"],
    }
  );

export const LoginSchema = zod
  .object({
    correo: zod.string().email({ message: "Debe ingresar un correo valido" }),
    pwd: zod
      .string({ message: "Debe ingresar una contraseña" })
      .min(6, { message: "La contraseña debe ser de al menos 6 digitos" }),
  })
  .refine((data) => {
    return (data.correo = data.correo.trim());
  });

export const PasswordResetRequestSchema = zod.object({
  correo: zod.string().email({ message: "Debe ingresar un correo valido" }),
});

export const PasswordResetSchema = zod
  .object({
    correo: zod.string().email({ message: "Debe ingresar un correo valido" }),
    pwd: zod
      .string()
      .min(8, { message: "La contraseña debe ser de al menos 8 digitos" })
      .regex(
        /[a-z]/,
        "La contraseña debe contener al menos una letra minúscula."
      )
      .regex(
        /[A-Z]/,
        "La contraseña debe contener al menos una letra mayúscula."
      )
      .regex(/[0-9]/, "La contraseña debe contener al menos un número.")
      .regex(
        /[\W_]/,
        "La contraseña debe contener al menos un carácter especial."
      ),
    pwdConfirmation: zod.string(),
  })
  .refine(
    (data) => {
      return data.pwd === data.pwdConfirmation;
    },
    {
      message: "Las contraseñas deben coinicidir.",
      path: ["pwdConfirmation"],
    }
  );

export const BillingFormSchema = zod.object({
  nombre: zod
    .string()
    .min(3, { message: "El nombre debe tener al menos 3 letras" }),
  apellido: zod
    .string()
    .min(3, { message: "El apellido debe tener al menos 3 letras" }),
  tipoDocumento: zod
    .string()
    .min(1, { message: "Debe seleccionar un tipo de documento" }),
  documento: zod
    .string()
    .min(1, { message: "El documento debe tener al menos 1 dígito" }),
  direccion: zod
    .string()
    .min(2, { message: "La dirección debe tener al menos 2 digitos" }),
  telefono: zod.string(),
  correo_cliente: zod
    .string()
    .email({ message: "Debe ingresar un correo valido" }),
});
